// extracted by mini-css-extract-plugin
module.exports = {"container":"Sq-z","copy":"Tq-z","field":"Uq-z","error":"Vq-z","disabled":"Wq-z","termsContainer":"Xq-z","termsHeading":"Yq-z","termsCopy":"Zq-z","submit":"_q-z","srOnly":"ar-z"};